var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"betshops__shops-list"},_vm._l((_vm.shops),function(shop){return _c('ShopInfo',{key:shop.id,attrs:{"city":shop.city,"address":shop.address,"openingHour":shop.openingHour,"closingHour":shop.closingHour},nativeOn:{"click":function($event){return _vm.$emit('shopListClick', shop)}}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb9ba0f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/modules/country/shops/components/ShopList.vue
// module id = 2212
// module chunks = 0